<template>
  <svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   inkscape:version="1.0rc1 (09960d6, 2020-04-09)"
   sodipodi:docname="tongue_L_triangle_4.svg"
   id="svg1118"
   version="1.1"
   viewBox="0 0 360 400"
   :height="height"
   :width="width">
  <defs
     id="defs1112">
      <filter id="blur">
         <feGaussianBlur in="SourceGraphic" stdDeviation="7,7" />
      </filter>
  </defs>
  <sodipodi:namedview
     inkscape:window-maximized="0"
     inkscape:window-y="23"
     inkscape:window-x="0"
     inkscape:window-height="755"
     inkscape:window-width="1252"
     scale-x="1"
     units="px"
     showgrid="false"
     inkscape:document-rotation="0"
     inkscape:current-layer="layer1"
     inkscape:document-units="px"
     inkscape:cy="187.25371"
     inkscape:cx="14.626807"
     inkscape:zoom="0.98994949"
     inkscape:pageshadow="2"
     inkscape:pageopacity="0.0"
     borderopacity="1.0"
     bordercolor="#666666"
     pagecolor="#ffffff"
     id="base" />
  <metadata
     id="metadata1115">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title />
      </cc:Work>
    </rdf:RDF>
  </metadata>
    <path
       d="M 0.49804688 0.49804688 L 0.49804688 399.50195 L 359.50195 399.50195 L 359.50195 0.49804688 L 0.49804688 0.49804688 z M 233.96289 22.080078 C 247.52002 21.873251 260.90548 30.236107 277.40234 62.482422 C 321.97234 149.60316 281.48543 376.90158 179.61719 377.91992 C 76.730624 373.84657 38.567943 149.17576 82.785156 61.927734 C 117.03658 -5.6560941 143.67085 33.411903 182.42383 33.505859 C 203.01135 33.555773 218.59814 22.314482 233.96289 22.080078 z "
       style="fill:#ff000000;stroke:#ffffff;stroke-width:0.996347;stroke-opacity:1"
       id="outside" />
    <path
       id="mouth"
       style="fill:#280b0b;stroke:#000000;stroke-width:0.879489;stroke-opacity:1"
       d="M 180 8.7871094 C 117.76101 8.7872428 67.307033 23.06088 67.308594 40.667969 C 67.309209 44.172234 69.354036 47.632602 73.294922 50.916016 C 109.96804 1.1915707 140.19737 34.844801 182.86328 34.931641 C 225.45643 35.018333 249.92493 0.77192744 286.61523 50.994141 C 290.61686 47.687824 292.69101 44.199899 292.69141 40.667969 C 292.69297 23.06088 242.23899 8.7872422 180 8.7871094 z " />
  <g id="cover_layer">
     <path
       sodipodi:nodetypes="szsss"
       inkscape:connector-curvature="0"
       id="cover"
       d="M 78.052898,58.513507 C 31.733719,135.23952 103.96673,336.39974 179.48817,336.39784 255.00961,336.39594 328.60914,135.61545 281.92039,59.00139 245.0541,-1.4944955 223.02351,33.60204 182.42831,33.519415 141.83312,33.43679 113.93253,-0.91979077 78.052898,58.513507 Z"
       style="display:inline;fill:none;stroke:#ff000000;stroke-width:2.07345px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
  </g>
  <g
     id="body_layer"
     inkscape:groupmode="layer"
     inkscape:label="Layer 1">
    <path
       sodipodi:nodetypes="szsss"
       inkscape:connector-curvature="0"
       id="body"
       d="M 65.1908,63.109968 C 12.970565,149.61085 94.406047,376.39885 179.54891,376.39671 264.69177,376.39457 347.66786,150.03468 295.03097,63.660008 253.46792,-4.543044 228.63064,35.024785 182.86362,34.931633 137.09661,34.838482 105.64149,-3.895122 65.1908,63.109968 Z"
       style="display:inline;fill:#f59a9a;stroke:#ff000000;stroke-width:2.33761px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
    <path
       d="M 180.63672 280.70312 C 151.95169 280.64475 123.42549 287.68672 93.662109 302.75391 C 101.99479 317.79237 111.17305 331.30915 120.92773 342.53711 C 163.80789 331.38402 202.92296 331.97003 239.07227 341.80469 C 249.15723 330.15847 258.64461 316.12762 267.2168 300.51367 C 237.30331 287.68586 208.88764 280.76132 180.63672 280.70312 z "
       style="display:inline;fill:none;stroke:#000000;stroke-width:1.09084;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="lg" />
    <path
       d="M 183.95117 334.03516 C 163.76505 333.85357 142.68337 336.46229 120.60938 342.16602 C 137.23248 361.40966 155.52712 374.01465 174.13867 376.08594 C 175.6653 376.2203 177.20605 376.31726 178.75781 376.38086 C 179.02159 376.3852 179.28498 376.39649 179.54883 376.39648 C 200.16144 376.39597 220.64032 363.10356 239.10547 341.76758 C 221.45823 336.89031 203.10738 334.20748 183.95117 334.03516 z "
       style="display:inline;fill:none;stroke:#000000;stroke-width:1.09084;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="he" />
    <path
       d="M 243.73025,23.603849 C 225.58458,23.836246 207.17669,34.98127 182.86297,34.931783 137.09595,34.838633 105.6414,-3.8949964 65.190705,63.110094 60.872484,70.263078 57.233318,78.363676 54.233855,87.179272 152.74497,102.19418 231.67326,97.097753 305.80669,87.073859 302.85464,78.496617 299.27373,70.622368 295.03121,63.660582 275.54853,31.6904 259.74113,23.398793 243.73025,23.603849 Z"
       style="display:inline;fill:none;stroke:#000000;stroke-width:1.09084;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="k-bl-li"
       inkscape:connector-curvature="0" />
    <path
       d="M 305.28516 87.445312 L 259.85352 92.607422 C 276.2304 168.79223 271.55728 231.5265 258.62891 296.77734 L 267.13281 300.66602 C 302.46614 236.39442 322.36423 145.6078 305.28516 87.445312 z "
       style="display:inline;fill:none;stroke:#000000;stroke-width:1.09084;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="lv-gb-l" />
    <path
       d="M 54.837891 87.498047 C 37.944149 146.36755 57.974389 238.17947 93.501953 302.46484 L 100.77539 298.59766 C 88.719226 229.14373 85.013837 165.17167 99.042969 92.980469 L 54.837891 87.498047 z "
       style="display:inline;fill:none;stroke:#000000;stroke-width:1.09084;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="lv-gb-r" />
    <path
       id="st-sp"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.83935;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="M 100.77805,298.59882 C 88.721886,229.14497 85.016226,165.1704 99.045358,92.979193 158.44052,98.535803 210.74588,97.146434 259.85971,92.633115 276.22935,168.80523 271.55566,231.53558 258.62894,296.7784 198.2707,273.69138 155.88995,276.19296 100.77805,298.59851 Z"
       inkscape:connector-curvature="0"
       sodipodi:nodetypes="cccccc" />
  </g>
</svg>
</template>

<script>
export default {
   props: {
      fragmented: {
         default: false
      },
      height: {
         default: 400
      },
      width: {
         default: 360
      }
   },
	mounted() {
		this.$emit('mounted');
	}
}
</script>